var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center bg-green-50 px-4 py-2 my-4 text-green-700 border border-green-300 rounded-lg",domProps:{"textContent":_vm._s(_vm.msg)}})}
var staticRenderFns = []

export { render, staticRenderFns }